module.exports = {
  slug: `did-they-say-that`,
  title: `Did A Judge REALLY Say That?! Take The Quiz Now`,
  meta: {
    title: `Did A Judge REALLY Say That?! Take The Quiz Now`,
    desc: `Will you get 100%? Hardly anyone does!`,
    image: require(`../assets/bars_mob.jpg`),
    whatsapp: `I just took this Amnesty quiz to see how many of these shocking quotes come from real judges – I thought you’d want to see it too!`
  },
  header: {
    title: `DID A JUDGE <i>REALLY</i> &nbsp;SAY THAT?<br>TAKE THE QUIZ NOW`,
    subtitle: `When it comes to judges and justice, can you spot the fact from the ﬁction? The answers might surprise you...`
  },
  questions: [
    {
      backgroundImage: require('../assets/hammer1.jpg'),
      backgroundImageMob: require('../assets/hammer1_mob.jpg'),
      question: '"I\'m not a gynecologist, but I can tell you something. If someone doesn\'t want to have sexual intercourse, the body shuts down.” <div class="spacing"></div>Did a judge really say this in 2012?',
      answers: [
        'No, that’s too horrible to be true ',
        'Yes, they did '
      ],
      userAnswer: null,
      answer: 1,
      answerText: 'Yes, in 2012 a judge said a woman’s body can shut down rape'
    },
    {
      backgroundImage: require('../assets/shoes.jpg'),
      backgroundImageMob: require('../assets/shoes_mob.jpg'),
      question: 'In which country did a judge say in 2019:<div class="spacing"></div>“I cannot think of any more obviously fundamental human right than the right of a man to have sex with his wife”',
      answers: [
        'Italy',
        'UK',
        'Senegal'
      ],
      userAnswer: null,
      answer: 1,
      answerText: '“I cannot think of any more obviously fundamental human right than the right of a man to have sex with his wife” – UK, 2019'
    },
    {
      backgroundImage: require('../assets/bars.jpg'),
      backgroundImageMob: require('../assets/bars_mob.jpg'),
      question: 'In 2015, a Mexican woman spent 12 hours in prison for doing what?',
      answers: [
        'Refusing to do her husband’s laundry',
        'Shouting at a dog',
        'Buying a handbag'
      ],
      userAnswer: null,
      answer: 0,
      answerText: 'She was imprisoned for refusing to do her husband’s laundry '
    },
    {
      backgroundImage: require('../assets/bleach.jpg'),
      backgroundImageMob: require('../assets/bleach_mob.jpg'),
      question: 'In 2017, a UK judge ruled that a woman who was forced to drink bleach by her husband was “not vulnerable” because she had...',
      answers: [
        'Friends',
        'A job',
        'A house'
      ],
      userAnswer: null,
      answer: 0,
      answerText: 'She was “not vulnerable” because she had friends '
    },
    {
      backgroundImage: require('../assets/cuff.jpg'),
      backgroundImageMob: require('../assets/cuff_mob.jpg'),
      question: 'In El Salvador, how long can a woman be jailed for if she has a miscarriage?',
      answers: [
        '3 months',
        '30 years',
        'Nobody can be jailed for having a miscarriage'
      ],
      userAnswer: null,
      answer: 1,
      answerText: 'In El Salvador, a woman can be jailed for 30 years after a miscarriage'
    },
    {
      backgroundImage: require('../assets/walking.jpg'),
      backgroundImageMob: require('../assets/walking_mob.jpg'),
      question: 'In Yemen, a woman’s testimony in court is…',
      answers: [
        'Worth half a man’s',
        'Worth twice a man’s',
        'Illegal'
      ],
      userAnswer: null,
      answer: 0,
      answerText: 'In Yemen, a woman’s testimony is worth half a man’s'
    },
    {
      backgroundImage: require('../assets/yellow.jpg'),
      backgroundImageMob: require('../assets/yellow_mob.jpg'),
      question: 'And finally – if you were a woman in Iran, how long could you go to prison for removing your headscarf?',
      answers: [
        '20 days',
        '20 months',
        '20 years'
      ],
      userAnswer: null,
      answer: 2,
      answerText: 'In Iran, a woman can go to prison for 20 years for removing her headscarf'
    },
  ],
  signAsk: {
    image: require('../assets/close_hammer.jpg'),
    imageMob: require('../assets/close_hammer_mob.jpg'),
    title: `Before you get your results...`,
    copy: `<p>For women around the world, a courtroom can often mean anything but justice.</p>
    <p>Women still face discrimination and harmful stereotypes – even from the systems meant to protect them.</p>
    <p>At Amnesty, we believe the legal system should protect women's rights, not perpetuate sexism.</p>`,
    question: `<p>Will you add your name to say you agree?</p>`,
    yes_btn: `Yes, absolutely`,
    no_btn: `No, sorry`
  },
  sign: {
    image: require('../assets/close_hammer.jpg'),
    imageMob: require('../assets/close_hammer_mob.jpg'),
    title: `THAT’S GREAT, THANK YOU!`,
    subTitle: `I believe the legal system should protect women's rights, not perpetuate sexism.`,
    subTitle_quote: true,
    petitionTitle: `ADD YOUR NAME:`,
    EN_URL: `https://actions.amnesty.org.uk/page/57329/petition/1`
  },
  shareAsk: { // / results screen
    image: require('../assets/close_hammer.jpg'),
    imageMob: require('../assets/close_hammer_mob.jpg'),
    question: `<p>Pretty shocking, eh? Now – will you share this quiz with your friends? You’ll be helping to spread awareness of the injustice women face around the world, and it takes just 30 seconds.</p>`,
    yes_btn: `Yes, I'll share `,
    no_btn: `No, sorry`
  },
  donateAsk: {
    image: require('../assets/close_hammer.jpg'),
    imageMob: require('../assets/close_hammer_mob.jpg'),
    title: `Before you go...`,
    copy: `<p>At Amnesty, we challenge discrimination wherever we find it – holding authorities to account and fighting for a fairer world for women.</p>
    <p>Can you chip in to fund the fight back today?</p>`,
    yes_btn: `Yes, I'll chip in`,
    donate_link: `https://www.amnesty.org.uk/giving/donate/give-now-handraiser?utm_campaign=WomensRightsQuiz&utm_source=WomensRightsQuiz&utm_medium=referral&utm_content=DonateButtonOn`,
    no_btn: `No, sorry`
  },
  thanks: {
    image: require('../assets/close_hammer.jpg'),
    imageMob: require('../assets/close_hammer_mob.jpg'),
    title: `THANKS FOR TAKING THE QUIZ`,
    copy: `<p>It highlights just a few startling stories about the injustice women face around the world.</p>
    <p>If, like us, you want to take action to help women achieve justice, take a look at some of our most urgent campaigns today.</p>`,
    btn_text: `SHOW ME URGENT CAMPAIGNS`,
    btn_link: `https://www.amnesty.org.uk/issues/womens-human-rights`
  }
}